import { useContext } from "react";

import FnrDeleteButton from "UI/FnrDeleteButton";

import stopEvents from "Utilities/stopEvents";

import { EditorContext } from "./Editor";

const DeleteButton = () => {
  const { deleteGift, active, isHoverFocused, isRequired } =
    useContext(EditorContext);
  if (isRequired) return null;
  return (
    <div onClick={stopEvents}>
      <FnrDeleteButton
        onClick={(e) => {
          deleteGift();
        }}
        variant="iconButton"
        confirmText="Are you sure? If you save, this cannot be undone."
        size="sm"
        popoverWidth={240}
        show={active || Boolean(isHoverFocused)}
      />
    </div>
  );
};

export default DeleteButton;
